import { Avatar, List, ListItem, ListItemAvatar, ListItemText, Divider, Box } from "@mui/material";

type Props = {
  members: { [name: string]: string, role: string }[];
}

export default function MembersList({ members }: Props) {
  return (
    <List sx={{}}>
      {members.filter(m => !!m.name).map(({ name, role }, index) => (
        <Box key={index}>
          <ListItem>
            <ListItemAvatar>
              <Avatar alt="Member Icon" />
            </ListItemAvatar>
            <ListItemText primary={name} secondary={role} />
          </ListItem>
          <Divider />
        </Box>
      ))}
    </List>
  );
}